import 'core-js/proposals/reflect-metadata';
import { jsonProperty, Serializable } from 'ts-serializable';

class DiarioAttach extends Serializable {
    @jsonProperty(Number)
    id: number = -1;

    @jsonProperty(String)
    filename: string = '';

    @jsonProperty(String)
    filepath: string = '';

    constructor() {
        super();
    }
}

export default DiarioAttach;
